/**
 * GraphQL Query
 * ダッシュボード画面
 */

/**
 * お知らせ一覧
 */
export const GRAPH_QL_QUERY_NOTICE_LIST = `
  query {
    notices (?) {
      edges {
        node {
          uuid
          type
          tag
          category
          message
          link
          linkText
          createdAt
        }
      }
      totalCount
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/dashboard.js